// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type TournamentsCountQueryVariables = Exact<{
  site?: string | null | undefined;
  onlyCurrent?: boolean | null | undefined;
  onlyFuture?: boolean | null | undefined;
  onlyPast?: boolean | null | undefined;
  onlyMy?: boolean | null | undefined;
  excludeTournamentIds?: Array<string | null | undefined> | string | null | undefined;
}>;


export type TournamentsCountQuery = { casinoTournamentsPublic: { id: string | undefined, tournamentsCount: number | undefined } | undefined };


export const TournamentsCountQueryDocument = gql`
    query TournamentsCountQuery($site: String, $onlyCurrent: Boolean, $onlyFuture: Boolean, $onlyPast: Boolean, $onlyMy: Boolean, $excludeTournamentIds: [String]) {
  casinoTournamentsPublic {
    id
    tournamentsCount(
      site: $site
      onlyCurrent: $onlyCurrent
      onlyFuture: $onlyFuture
      onlyPast: $onlyPast
      onlyMy: $onlyMy
      excludeTournamentIds: $excludeTournamentIds
    )
  }
}
    `;